import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useDrag, DragSourceMonitor } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";

interface IHeroSlidePreviewProps {
  slideImage: { src: string; alt?: string }; // extend with other fields as needed
  index: number;
  selected: boolean;
  onClick?: () => void;
}

export const HERO_SLIDE_DND_TYPE = "HERO_SLIDE";

export default observer(function HeroSlidePreview ({
  slideImage,
  index,
  selected,
  onClick,
} : IHeroSlidePreviewProps) {
  // --- DnD setup ---
  const [{ isDragging }, dragRef, previewRef] = useDrag({
    type: HERO_SLIDE_DND_TYPE,
    item: { index }, // minimal payload!
    collect: (monitor: DragSourceMonitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  useEffect(() => {
    previewRef(getEmptyImage(), { captureDraggingState: true });
  }, [previewRef]);

  return (
    <div
      ref={dragRef}
      tabIndex={0}
      className={`
        w-[150px] h-[110px] rounded-md
        flex items-center justify-center
        overflow-hidden
        shadow ${selected ? "ring-2 ring-blue-400" : "ring-1 ring-gray-400/50"}
        border ${selected ? "border-blue-400" : "border-gray-300"}
        cursor-move
        bg-gray-100
        transition-all
        ${isDragging ? "opacity-60 scale-95 z-20" : "opacity-100 z-10"}
        outline-none
      `}
      onClick={onClick}
      aria-selected={selected}
      aria-label={`Slide ${index + 1}`}
      style={{
        userSelect: "none",
        boxShadow: isDragging
          ? "0 6px 24px 0 rgba(60,120,255,0.16)"
          : "0 1.5px 7px 0 rgba(30, 41, 59, 0.08)",
      }}
    >
      <img
        src={slideImage.src}
        alt={slideImage.alt || `Hero Slide ${index + 1}`}
        className="w-full h-full object-cover pointer-events-none"
        draggable={false}
      />
      {/* You can add captions, overlay controls, etc. here */}
    </div>
  );
});